// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createAccountStyles } from "@insite/content-library/Widgets/CreateAccount/CreateAccount";
import { hideElement, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

createAccountStyles.userGridItem = {
    width: [12, 12, 12, 5, 5],
    css: css`
        flex-direction: column;
    `,
};

createAccountStyles.userGridContainer = {
    gap: 20,
    css: css`
        &&& {
            max-width: 450px;
        }
    `,
};

createAccountStyles.submitGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
    `,
};

createAccountStyles.reCaptchaGridItem = {
    width: 12,
    css: css`
        &:empty {
            ${hideElement}
        }
    `,
};

createAccountStyles.requirementsGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
    `,
};

createAccountStyles.mainGridContainer = {
    offsetCss: css`
        ${xScreen("gt", "lg")} {
            gap: 30px;
        }
    `,
};

createAccountStyles.submitButton = {
    css: css`
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};
